import { IGeneralAllLang } from '../../../types/lang'
import { generalLang } from './general'


export const generalAllLang: IGeneralAllLang = {
	...generalLang,
}